module.exports = __webpack_public_path__ + "static/media/icon-telegram.aae357da.svg";